/* eslint-disable */
import React, {PropTypes} from 'react';

class InciaRating extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        
    }
    componentDidMount() {
        window.RatingTF.init();
 
    }
    componentWillReceiveProps(nextProps){
        if(this.props.carregar!==nextProps.carregar){
            
            window.RatingTF.init();
        }
    }

    
    render() {
    
    return (
        <div />
   );
  }
}




export default InciaRating;



/** WEBPACK FOOTER **
 ** ./src/components/InciaRating.js
 **/